module.exports = __webpack_public_path__ + "img/house_fill.b3874864.svg";